<div class="container-fluid py-2">
  <div class="row">
    <div class="col-12">
      <div class="card shadow-sm p-4">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h5 class="fw-bold">Existing Testimonials</h5>
          <!-- Add Testimonial Button -->
          <button class="btn btn-primary btn-sm" (click)="isModalVisible = true">
            <i class="fas fa-plus me-1"></i> Add Testimonial
          </button>
        </div>

        <div class="row col-10 mx-auto my-3">
  <ng-container *ngIf="testimonialDetails && testimonialDetails.length; else noData">
<div class="card mb-3" *ngFor="let it of testimonialDetails">
  
  <!-- Card Header with Edit & Delete Buttons -->
  <div class="card-header d-flex justify-content-end align-items-center gap-2 p-2">
                  <!-- Custom Small Toggle -->
              <label class="switch m-0" title="Click to change Status">
                <input type="checkbox" [checked]="it.status === 'Active'" (change)="toggleStatus(it.testimonialSeq, $event)" />
                <span class="slider round"></span>
              </label>

    <button 
      class="btn btn-sm btn-outline-primary me-1" 
      title="Click to update" 
      (click)="editTestimonial(it)"
    >
      <i class="bi bi-pencil-fill"></i>
    </button>
    <button 
      class="btn btn-sm btn-outline-danger" 
      title="Click to delete" 
      (click)="deleteTestimonial(it.testimonialSeq)"
    >
      <i class="bi bi-trash-fill"></i>
    </button>
  </div>

  <!-- Card Body -->
  <div class="card-body pt-2">
    <h6 class="card-text text-justify mb-2" [innerHTML]="it.description"></h6>
    <p class="text-end fw-semibold mb-0">– {{ it.testimonialBy }}</p>
  </div>

</div>

  </ng-container>

  <ng-template class="row d-flex justify-content-center" #noData>
 <tr class="row d-flex justify-content-center text-center">
    <td colspan="12" class="text-center py-3">
      <!-- Replace icon with social media icon (example: links icon) -->
      <i class="fas fa-users fa-2x d-block mb-2 text-secondary"></i>
      <span class="fw-bold text-secondary">-- No Testimonial's found --</span>
    </td>
  </tr>
</ng-template>

</div>


        <!-- Existing Testimonials List -->
       

      </div>
    </div>
  </div>
</div>


<!-- Add Testimonial Modal -->

   <div class="modal" 
     style="background-color: rgba(54,54,54,0.47)"
     tabindex="-1" role="dialog" 
     aria-hidden="true"
     [style.display]="isModalVisible ? 'block' : 'none'">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title fw-bold" id="addTestimonialLabel">Add New Testimonial</h5>
        <button type="button" class="btn-close" (click)="closeModel()" aria-label="Close"></button>
      </div>
      <div class="modal-body" style="max-height: 80vh; overflow-y: auto;">
        <form [formGroup]="addTestimonialForm" (ngSubmit)="testimonialFormValidation()">
  
  <!-- Testimonial Description -->
  <div class="mb-3">
    <label class="form-label">Testimonial Description</label>
   <quill-editor 
  class="quill-editor" 
  formControlName="description" 
  [modules]="quillModules"
  [ngClass]="{
    'is-invalid': addTestimonialForm.get('description')?.invalid && addTestimonialForm.get('description')?.touched,
    'is-valid': addTestimonialForm.get('description')?.valid && addTestimonialForm.get('description')?.touched
  }" 
  [style.minHeight.px]="120"
></quill-editor>

    <small class="text-danger fw-bold" *ngIf="addTestimonialForm.get('description')?.touched && addTestimonialForm.get('description')?.invalid">
      <i class="fas fa-exclamation-circle"></i> {{ testimonialFormErrors.description }}
    </small>
      <small class="text-danger fw-bold" *ngIf="maxCharacter">
      <i class="fas fa-exclamation-circle"></i> {{ testimonialFormErrors.description }}
    </small>
  </div>

  <!-- Testimonial By & Title -->
  <div class="row">
    <div class="col-md-12">
      <div class="mb-3">
        <label class="form-label">Testimonial By</label>
        <input type="text" class="form-control" formControlName="testimonialBy" placeholder="e.g., John Doe">
        <small class="text-danger fw-bold" *ngIf="addTestimonialForm.get('testimonialBy')?.touched && addTestimonialForm.get('testimonialBy')?.invalid">
          <i class="fas fa-exclamation-circle"></i> {{ testimonialFormErrors.testimonialBy }}
        </small>
      </div>
    </div>
    <!-- <div class="col-md-6">
      <div class="mb-3">
        <label class="form-label">Testimonial Title</label>
        <input type="text" class="form-control" formControlName="title" placeholder="e.g., CEO, Company XYZ">
        <small class="text-danger fw-bold" *ngIf="addTestimonialForm.get('title')?.touched && addTestimonialForm.get('title')?.invalid">
          <i class="fas fa-exclamation-circle"></i> {{ testimonialFormErrors.title }}
        </small>
      </div>
    </div> -->
  </div>

  <!-- Rating -->
  <!-- <div class="mb-3">
    <label class="form-label">Rating</label>
    <div class="d-flex gap-1">
      <i class="far fa-star text-warning" *ngFor="let star of [1,2,3,4,5]"></i>
    </div>
  </div> -->

  <!-- Thumbnail Upload -->
  <!-- <div class="mb-3">
    <label class="form-label">Thumbnail Image</label>
    <input type="file" class="form-control" (change)="onFileSelected($event)" accept="image/*">
    <small class="text-danger fw-bold" *ngIf="testimonialFormErrors.base64Code">
      <i class="fas fa-exclamation-circle"></i> {{ testimonialFormErrors.base64Code }}
    </small>
  </div> -->
</form>

      </div>
      <div class="modal-footer">
        <button class="btn btn-secondary" data-bs-dismiss="modal" (click)="closeModel()">Cancel</button>
        <button class="btn btn-primary" (click)="testimonialFormValidation()">{{ isUpdate ? 'Update' : 'Save Testimonial' }}</button>
      </div>
    </div>
  </div>
</div>







<ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium">
    <div class="loader">
        <div class="inner one"></div>
        <div class="inner two"></div>
        <div class="inner three"></div>
    </div>
</ngx-spinner>